import styled from 'styled-components';

export const Select = styled.select`
  margin-top: 0;
  height: 48px;
  border: solid 1px ${({ theme }) => theme.borderColorDisabled};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${({ theme }) => theme.onBackgroundColor};
  outline: none;
  appearance: none;
  cursor: pointer;
  &:focus {
    border: solid 1px ${({ theme }) => theme.primaryColor};
  }
`;

export const Option = styled.option`
  &:checked {
    width: 304px !important;
    background: #f5f5f5;
    color: ${({ theme }) => theme.primaryColor};
  }
  min-width: 304px !important;
`;
export const Label = styled.label`
  position: relative;

  &:after {
    content: url('/assets/icons/arrow_selector.svg');
    width: 16px;
    height: 16px;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'none')};
    right: 23px;
    top: 16.5px;
    position: absolute;
    pointer-events: none;
  }
`;
